import { WEB3FORMS_KEY, WEB3FORMS_ENDPOINT } from '../../lib/forms'
import type { DevisAnswers } from './types'

/** Human-readable (localized) labels for the enum answers, resolved by the caller. */
export type BriefLabels = {
  sector: string
  sourcing: string
  zones: string
  platform: string
}

/**
 * Send the wizard brief to Web3Forms (→ contact@yaslan.be). Best-effort:
 * returns false on network/API failure and NEVER throws, so the booking step
 * can proceed regardless.
 */
export async function submitDevisBrief(a: DevisAnswers, l: BriefLabels): Promise<boolean> {
  const message = [
    `Secteur : ${l.sector}`,
    `Origine / sourcing : ${l.sourcing}`,
    `Panier moyen : ${a.avgBasket} €`,
    `Commandes / mois : ${a.ordersPerMonth}`,
    `Articles / colis : ${a.itemsPerParcel}`,
    `Poids / article : ${a.weightPerItem} g`,
    `Répartition livraison : Domicile ${a.homeDeliveryPct}% / Point relais ${100 - a.homeDeliveryPct}%`,
    `Zones de livraison : ${l.zones || '—'}`,
    `Plateforme : ${l.platform || '—'}`,
    `Site web : ${a.website || '—'}`,
  ].join('\n')

  const data = new FormData()
  data.append('access_key', WEB3FORMS_KEY)
  data.append('subject', 'Nouvelle demande de devis (wizard) — Yaslan')
  data.append('from_name', 'Yaslan Devis Wizard')
  data.append('name', a.name)
  data.append('email', a.email)
  data.append('phone', a.phone)
  data.append('message', message)

  try {
    const res = await fetch(WEB3FORMS_ENDPOINT, { method: 'POST', body: data })
    const json = (await res.json()) as { success?: boolean }
    return Boolean(json.success)
  } catch {
    return false
  }
}
